$(document).ready(function(){
    $('.js-date-of-birth').mask('00-00-0000', {
        placeholder: "dd-mm-jjjj"
    });
});
